import React, { useEffect, useState } from "react";
import TextInput from "../../Global Functions/textInput";

const Foodcourt = ({ onChange, propertyDataBackend }) => {
  const [propertyData, setPropertyData] = useState({
    total_quantity: "",
    no_of_seatings: "",
  });

  useEffect(() => {
    if (propertyDataBackend) {
      setPropertyData({
        total_quantity: propertyDataBackend.total_quantity || "",
        no_of_seatings: propertyDataBackend.no_of_seatings || "",
      });
    }
  }, [propertyDataBackend]);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    const updatedState = { ...propertyData, [name]: value };
    setPropertyData(updatedState);
    if (onChange) {
      onChange(updatedState);
    }
  };

  return (
    <div className="grid-span-2">
      <div className="grid-template-2 gap-10">
        <TextInput
          label="No. of Units"
          min={0}
          required
          value={propertyData.total_quantity || "N/A"}
          type="number"
          name="total_quantity"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Seating Capacity"
          min={0}
          required
          value={propertyData.no_of_seatings || "N/A"}
          type="number"
          name="no_of_seatings"
          onChange={handleAddChange}
        ></TextInput>
      </div>
    </div>
  );
};

export default Foodcourt;
